import { Point } from '@thive/fddm-types';

export const calculateDistance = (p1: Point, p2: Point): number => {
  const a = p1.x - p2.x;
  const b = p1.y - p2.y;
  return Math.sqrt(a * a + b * b);
};

export const merge = (target, source) => {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  Object.keys(source).forEach((key) => {
    if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]));
  });

  // Join `target` and modified `source`
  Object.assign(target || {}, source);
  return target;
};

export const isUuid = (input) => {
  const isString = typeof input === 'string' || input instanceof String;

  return (
    isString &&
    input.match(
      // Using this regex b/c the uuid library has a bug inside so it doesn't generate proper UUID v4s
      // A proper uuid check (8-4-4-12) is /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi,
      /^[0-9a-f]{1,8}\b-[0-9a-f]{1,4}\b-[0-9a-f]{1,4}\b-[0-9a-f]{1,4}\b-[0-9a-f]{1,12}$/g,
    )
  );
};

/**
 * @description utility function to check for exhaustiveness during compile-time
 */
export function assertNever(value: never): never {
  return value;
}
